'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$LimitedLocalTime(hour, minute) {
  this.op = 0;
  this.qe = 0;
  this.op = hour;
  this.qe = minute;
}
export { $c_Lpresto_types$LimitedLocalTime as $c_Lpresto_types$LimitedLocalTime };
$p = $c_Lpresto_types$LimitedLocalTime.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$LimitedLocalTime;
/** @constructor */
function $h_Lpresto_types$LimitedLocalTime() {
}
export { $h_Lpresto_types$LimitedLocalTime as $h_Lpresto_types$LimitedLocalTime };
$h_Lpresto_types$LimitedLocalTime.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("LimitedLocalTime"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.op);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.qe);
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().al(acc, 2);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$LimitedLocalTime) && ((this.op === x$0.op) && (this.qe === x$0.qe))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "LimitedLocalTime";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.op;
  }
  if ((n === 1)) {
    return this.qe;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.a3A = (function() {
  return (((("" + this.op) + ":") + ((this.qe < 10) ? "0" : "")) + ("" + this.qe));
});
$p.cJr = (function(other) {
  return ((this.op === other.op) ? (this.qe < other.qe) : (this.op < other.op));
});
function $isArrayOf_Lpresto_types$LimitedLocalTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jV)));
}
export { $isArrayOf_Lpresto_types$LimitedLocalTime as $isArrayOf_Lpresto_types$LimitedLocalTime };
var $d_Lpresto_types$LimitedLocalTime = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$LimitedLocalTime, "presto.types$LimitedLocalTime", ({
  jV: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$LimitedLocalTime as $d_Lpresto_types$LimitedLocalTime };
//# sourceMappingURL=presto.types$-Limited-Local-Time.js.map
